// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-checkout__sidbar',
    // #endregion
    // #region Events
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        cart: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        status: {
            type: Object,
            required: true,
            default: {}
        }
    },
    // #endregion
    // #region Methods
    methods: {
        // #region Commands
        cmdRenameCart() {
            let tData = {
                callback: () => this.$emit('command', { name: "load" }),
                cartName: this.cart.cartName,
                cartID: this.cart.cartID
            };
            host.notification.showModal(host.components.getComponent('g-cart-create-dialog'), tData, { size: 'default' });
        },
        // #endregion
        // #region Helper
        getFontStyle(item) {
            //new
            let tItem = {};
            //Bold
            if (item.fontBold) {
                tItem['font-weight'] = 'bold';
            }
            //Color
            if (item.fontColor) {
                tItem['color'] = item.fontColor;
            }
            return tItem;
        },
        // #endregion
    }
    // #endregion
});
// #endregion
